import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, merge, mergeMap, of, pipe, switchMap, take, tap } from "rxjs";
import { DeviceService } from "src/app/devices/services/device.service";
import * as AppActions from "./actions";
import { AppNotificationService } from "src/app/shared/services/notification.service";
import { translate } from '@jsverse/transloco';
import { IDeviceCategory } from "src/app/devices/models/device-category";

@Injectable()
export class DeviceCategoriesEffets {

    //////////////////////////
    // GET DEVICE CATEGORY //
    ////////////////////////

    // Get Device Category
    getDeviceCategories$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.getDeviceCategories), 
            mergeMap(() => {
            return this.deviceService.getAllDeviceCategories({pageNumber: 0, pageSize: 25}).pipe(
                map((response) => 
                    AppActions.getDeviceCategoriesSuccess({ deviceCategories: response.data })
                ), 
                catchError((error) =>
                    of(AppActions.getDeviceCategoriesFailure({ error: error.message }))
                )
            );
        }),
        take(1)
        )
    );




    /////////////////////////////
    // CREATE DEVICE CATEGORY //
    ///////////////////////////

    // Create Device Category
    createDeviceCategory$ = createEffect(() =>
      this.actions$.pipe(
          ofType(AppActions.createDeviceCategory),
          mergeMap((action) => 
              this.deviceService.createDeviceCategory(action.deviceCategory).pipe(
                  map((deviceCategory: IDeviceCategory) => AppActions.createDeviceCategorySuccess({ deviceCategory })),
                  catchError((error) => of(AppActions.createDeviceCategoryFailure({ error: error.message })))
              )
          )
      )
    );

    // Device Category created successfully
    createDeviceCategorySuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(AppActions.createDeviceCategorySuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.deviceCategories.createSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );

    // Device Category not created successfully
    createDeviceCategoryFailure$ = createEffect(() => 
      this.actions$.pipe(
          ofType(AppActions.createDeviceCategoryFailure)
      ), { dispatch: false }
    );




    /////////////////////////////
    // UPDATE DEVICE CATEGORY //
    ///////////////////////////

    // Update Device Category
    updateDeviceCategory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.updateDeviceCategory),
            mergeMap((action) => 
                this.deviceService.updateDeviceCategory(action.deviceCategory).pipe(
                    map((deviceCategory: IDeviceCategory) => AppActions.updateDeviceCategorySuccess({ deviceCategory })),
                    catchError((error) => of(AppActions.updateDeviceCategoryFailure({ error: error.message })))
                )
            )
        )
    );
  
    // Update Device Category successful
    updateDeviceCategorySuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(AppActions.updateDeviceCategorySuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.deviceCategories.updateSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );
  
    // Device Category not updated successfully
    updateDeviceCategoryFailure$ = createEffect(() => 
        this.actions$.pipe(
            ofType(AppActions.updateDeviceCategoryFailure)
        ), { dispatch: false }
    );




    /////////////////////////////
    // DELETE DEVICE CATEGORY //
    ///////////////////////////

    // Delete Device Category
    deleteDeviceCategory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.deleteDeviceCategory), 
            mergeMap((action) => {
                return this.deviceService.deleteDeviceCategory(action.id).pipe(
                    map(() => AppActions.deleteDeviceCategorySuccess({id: action.id})), 
                    catchError((error) => of(AppActions.deleteDeviceCategoryFailure({ error: error.message })))
            )}
        ))
    );

    // Device Category deleted successfully
    deleteDeviceCategorySuccess$ = createEffect(() => 
      this.actions$.pipe(
          ofType(AppActions.deleteDeviceCategorySuccess),
          tap(() => {
              this.appnotificationService.notification$.next({ message:translate('settings.deviceCategories.deleteSuccess'), style: 'success' });
          })
      ), { dispatch: false }
    );

    // Device Category not deleted successfully
    deleteDeviceCategoryFailure$ = createEffect(() =>
      this.actions$.pipe(
        ofType(AppActions.deleteDeviceCategoryFailure)
      ), { dispatch: false }
    );




    constructor(
        private actions$: Actions, 
        private deviceService: DeviceService,
        private appnotificationService: AppNotificationService) {}
}